const WEMFacebook = 'https://www.facebook.com/Westedmall/';
const WEMInstagram = 'https://www.instagram.com/official_wem/';
const WEMTwitter = 'https://twitter.com/Official_WEM';

export { WEMFacebook, WEMInstagram, WEMTwitter };
